import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  isOpen: false
};

export const catalogCartSlice = createSlice({
  name: 'catalogCart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const product = action.payload;
      const existingItem = state.items.find(item => item.id === product.id);
      
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        state.items.push({ ...product, quantity: 1 });
      }
    },
    removeFromCart: (state, action) => {
      const productId = action.payload;
      state.items = state.items.filter(item => item.id !== productId);
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const item = state.items.find(item => item.id === id);
      if (item && quantity > 0) {
        item.quantity = quantity;
      } else if (item && quantity === 0) {
        state.items = state.items.filter(item => item.id !== id);
      }
    },
    clearCart: (state) => {
      state.items = [];
    },
    toggleCart: (state) => {
      state.isOpen = !state.isOpen;
    },
    setCartOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    updateCartPrices: (state, action) => {
      const updatedProducts = action.payload;
      state.items = state.items.map(item => {
        const updatedProduct = updatedProducts.find(p => p.id === item.id);
        if (updatedProduct) {
          return {
            ...item,
            price: updatedProduct.price,
            iva: updatedProduct.iva
          };
        }
        return item;
      });
    }
  }
});

export const { 
  addToCart, 
  removeFromCart, 
  updateQuantity, 
  clearCart, 
  toggleCart,
  setCartOpen,
  updateCartPrices 
} = catalogCartSlice.actions;

export default catalogCartSlice.reducer;
